// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oMqG","question":"styles_question__3fZXX","description":"styles_description__n277Z"};